<div class="roster-container">
  <!-- Top Navigation Bar -->
  <header class="app-bar">
    <div class="app-right-icon">
      <mat-icon>calendar_today</mat-icon>
    </div>
    <h1 class="app-title">Your Roster</h1>
    <button mat-icon-button (click)="logout()" class="back-btn" aria-label="Logout">
      <mat-icon>logout</mat-icon>
    </button>
  </header>

  <!-- Employee Info Card -->
  <div class="employee-card">
    <div class="card-left">
      <div class="emp-avatar">
        <!-- SVG Avatar representing a user -->
        <svg viewBox="0 0 100 100" class="avatar-svg">
          <circle cx="50" cy="38" r="18" fill="#e2e8f0" />
          <path d="M50 62c-20 0-32 10-32 20v4h64v-4c0-10-12-20-32-20z" fill="#cbd5e1" />
        </svg>
      </div>
      <div class="emp-details">
        <h2 class="emp-name">{{ employeeInfo?.preferred_name || employeeInfo?.first_name }} {{ employeeInfo?.last_name
          }}</h2>
        <p class="emp-id">Employee ID: {{ employeeInfo?.employee_id }}</p>
      </div>
    </div>

    <!-- Shop Filter Dropdown -->
    <div class="shop-filter-container">
      <div class="shop-select-wrapper" 
           [class.clickable]="uniqueShops.length > 1"
           (click)="uniqueShops.length > 1 && toggleShopDropdown()">
        <mat-icon class="shop-icon">storefront</mat-icon>
        <div class="select-labels">
          <span class="select-hint">Shops</span>
          <span class="selected-shop-name">{{ getSelectedShopName() }}</span>
        </div>
        <mat-icon class="dropdown-arrow" 
                  *ngIf="uniqueShops.length > 1"
                  [class.open]="isShopDropdownOpen">
          keyboard_arrow_down
        </mat-icon>
      </div>

      <!-- Custom styled inline dropdown items list -->
      <div class="custom-dropdown-list" *ngIf="isShopDropdownOpen && uniqueShops.length > 1">
        <div class="dropdown-item" 
             [class.active]="selectedShopCode === 'ALL'"
             (click)="selectShop('ALL'); $event.stopPropagation()">
          All Shops
        </div>
        <div class="dropdown-item" 
             *ngFor="let shop of uniqueShops" 
             [class.active]="selectedShopCode === shop.code"
             (click)="selectShop(shop.code); $event.stopPropagation()">
          {{ shop.name }}
        </div>
      </div>
    </div>
  </div>

  <!-- Week Navigation -->
  <div class="week-navigation">
    <button (click)="prevWeek()" class="nav-arrow-btn" aria-label="Previous Week">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <div class="week-label-container">
      <h3 class="week-title">Week {{ currentWeek }} <mat-icon class="chevron-down">keyboard_arrow_down</mat-icon></h3>
      <p class="week-dates">{{ weekStartStr }} – {{ weekEndStr }}</p>
    </div>
    <button (click)="nextWeek()" class="nav-arrow-btn" aria-label="Next Week">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <!-- Task Legends -->
  <!-- Task Legends Card -->
  <div class="tasks-card" *ngIf="taskLegends.length > 0">
    <div class="tasks-header">
      <div class="header-left">
        <mat-icon class="tasks-header-icon">assignment</mat-icon>
        <span class="tasks-header-title">Tasks</span>
      </div>
      <mat-icon class="tasks-header-info">info_outline</mat-icon>
    </div>

    <div class="tasks-grid">
      <div class="tasks-grid-cell" *ngFor="let legend of taskLegends" [class.empty-cell]="!legend.code">
        <ng-container *ngIf="legend.code">
          <span class="legend-badge" [style.color]="legend.bg_color || '#475569'"
            [style.border-color]="legend.bg_color || '#e2e8f0'">
            {{ legend.code }}
          </span>
          <span class="legend-name">{{ legend.name }}</span>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- Shifts Day List -->
  <div class="shifts-list">
    <div class="loading-state" *ngIf="isLoading">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Loading your roster...</p>
    </div>

    <div class="empty-state" *ngIf="!isLoading && filteredShifts.length === 0">
      <mat-icon class="empty-icon">calendar_today</mat-icon>
      <h3>No Shifts Found</h3>
      <p>You have no rostered shifts for Week {{ currentWeek }}, {{ currentYear }}.</p>
    </div>

    <div class="shift-card" *ngFor="let shift of filteredShifts" [class.today]="shift.isToday">
      <!-- Date Block -->
      <div class="date-block">
        <span class="day-name">{{ shift.dayName | uppercase }}</span>
        <span class="day-number">{{ shift.dayStr }}</span>
        <span class="month-name">{{ shift.monthStr }}</span>
      </div>

      <!-- Shift Details Block -->
      <div class="shift-details">
        <!-- Badges & Time Row -->
        <div class="details-top">
          <div class="task-badges">
            <!-- <span class="badge" *ngIf="shift.position_code" [style.color]="shift.position_fg_color || '#475569'"
              [style.border-color]="shift.position_fg_color || '#cbd5e1'">
              {{ shift.position_code }}
            </span> -->
            <span class="badge" *ngIf="shift.task1_code" [style.color]="shift.task1_bg_color || '#475569'"
              [style.border-color]="shift.task1_bg_color || '#cbd5e1'">
              {{ shift.task1_code }}
            </span>
            <span class="badge" *ngIf="shift.task2_code" [style.color]="shift.task2_bg_color || '#1e40af'"
              [style.border-color]="shift.task2_bg_color || '#bfdbfe'">
              {{ shift.task2_code }}
            </span>
            <span class="badge" *ngIf="shift.task3_code" [style.color]="shift.task3_bg_color || '#92400e'"
              [style.border-color]="shift.task3_bg_color || '#fde68a'">
              {{ shift.task3_code }}
            </span>
            <span class="badge cutting"
              *ngIf="shift.is_salmon_cutting === '1' || shift.is_salmon_cutting === 1">SC</span>
            <span class="badge incharge" *ngIf="shift.is_in_charge === '1' || shift.is_in_charge === 1">IC</span>
          </div>

          <div class="shift-hours">
            {{ shift.hoursStr }}
          </div>
        </div>

        <div class="details-middle">
          <div class="time-range">
            {{ shift.startTimeStr }} - {{ shift.endTimeStr }}
          </div>
          <div class="shop-name">
            <mat-icon class="small-icon">store</mat-icon>
            {{ shift.shop_name }}
          </div>
        </div>

        <!-- Break Details/Notes if present -->
        <div class="details-bottom" *ngIf="shift.notesJoined || shift.comment">
          <div class="notes" *ngIf="shift.notesJoined">
            <strong>Tasks:</strong> {{ shift.notesJoined }}
          </div>
          <div class="comment" *ngIf="shift.comment">
            <strong>Notes:</strong> {{ shift.comment }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Bottom Important Note -->
  <footer class="important-note">
    <div class="note-content">
      <mat-icon class="info-icon">info_outline</mat-icon>
      <p><strong>Note:</strong> Timings are subject to change. Please check regularly.</p>
    </div>
  </footer>
</div>